module.exports = __webpack_public_path__ + "img/appointmentConfirmationRight.b5e199db.png";